import React, { useState } from "react";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";
import "../commonStyle.css";
import EnterNumber from "./EnterNumber";
import { isMobile } from "../helperFunc";
import Loader from "../CommonComponents/Loader/Loader";
import { URL_CONFIG } from "../../../../_constants/Config/URL_CONFIG";
import uatQRLink from "./../DesktopImages/Home/uatQRLink.png";
import uatAryaShaktiLink from "./../DesktopImages/Home/uat3_aryashakti.png";
import liveAryaShaktiLink from "./../DesktopImages/Home/live_aryashakti.png";

import liveQRLink from "./../DesktopImages/Home/liveQRLink.png";

const DownloadLink = ({ className = "", aryaShakti = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  let pngImage = URL_CONFIG.IMG_URL + "arya2/downloadImage.png";

  //   const [showWidget, setShowWidget] = useState(false);

  //   const [mobileNumber, setMobileNumber] = useState("");
  // const submitNumber = (number) => {
  //   setMobileNumber(number);
  //   setStepNo(1);
  // };
  //   const isUserSubscribed = async () => {
  //     const res = await getWhatsappSubscribe();
  //     if (res?.data?.flag) {
  //       setShowWidget(false);
  //     } else setShowWidget(true);
  //   };
  //   useEffect(() => {
  //     if (userLoggedIn) {
  //       isUserSubscribed();
  //       setMobileNumber(userDetails?.phone_number);
  //     } else {
  //       setShowWidget(true);
  //     }
  //   }, [userLoggedIn]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div
        className={`${className}  positionRelative  ${
          isMobile
            ? `${style["wa-container"]} margin16`
            : `${"left-right-margin-100"} top-bottom-margin-40 d-flex align-items-center justify-content-space-between boxRadius8 ${
                style["paddingDesktop"]
              }`
        }`}
      >
        <img
          className={`positionAbsolute  ${
            isMobile
              ? style["wa-img"]
              : `${style["imageDesktopCSS"]} boxRadius8`
          }`}
          src={pngImage}
          alt=""
        />
        <div className="">
          <HeadLines
            className={`font-weight600 textColorWhite margin-bottom8 ${
              isMobile ? "" : "font-size24 line-height28"
            }`}
            text={`${
              aryaShakti ? "Arya Shakti" : "arya.ag"
            } App is now available in your Language!`}
          />
          <HeadLines
            className={`colorLightGrey5  padding-top4 font-weight400 ${
              isMobile
                ? ` font-size12  padding-bottom16 line-height14 letterSpacing025`
                : "font-size16 line-height19 letterSpacing05"
            } ${style["max-width296"]}`}
            text={
              "Enter your Mobile number to receive a link to the app or scan the QR code."
            }
          />
        </div>
        {/* {stepNo ? (
          <EnterOtp
            setStepNo={setStepNo}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            setIsLoading={setIsLoading}
          />
        ) : ( */}
        <div>
          <EnterNumber
            // submitNumber={submitNumber}
            setIsLoading={setIsLoading}
            //   mobileNumber={mobileNumber}
            //   setShowWidget={setShowWidget}
            //   userLoggedIn={userLoggedIn}
            aryaShakti={aryaShakti}
          />
        </div>
        <div className="d-flex align-items-center colorDark1 gap20 justify-content-end">
          <div className="padding-left16">
            <HeadLines
              text="Scan this QR Code to"
              className={
                "text-right font-size20 line-height23 letterSpacing001 padding-bottom12"
              }
            />
            <HeadLines
              text={`Download ${aryaShakti ? "Arya Shakti" : "arya.ag"} App`}
              className={
                "text-right font-size20 line-height23 letterSpacing001"
              }
            />
          </div>
          <div>
            <img
              alt=""
              src={
                window?.location?.href?.includes("uat")
                  ? aryaShakti
                    ? uatAryaShaktiLink
                    : uatQRLink
                  : aryaShakti
                  ? liveAryaShaktiLink
                  : liveQRLink
              }
              height={120}
              width={120}
            />
          </div>
        </div>
        {/* )} */}
      </div>
    </>
  );
};
export default DownloadLink;
